Vendd.Scripts.load(function () {

    Vendd.Environment = (function () {

        var current = undefined;
        var available = [];

        var Environment = function () {

        };

        Environment.prototype.init = function (options) {

            current = options.current;
            available = options.available;

        };

        Object.defineProperty(Environment.prototype, "Current", {
            get: function Current() {
                return current;
            }
        });

        Object.defineProperty(Environment.prototype, "Available", {
            get: function Available() {
                return available;
            }
        });

        return new Environment();

    })();

});














Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-inline-widget');
    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);
    var model = null;
    var hasCookie = Cookies.get('InlineAdmin');

    if (hasCookie) {
        $('html').addClass('has-inline-admin');
    }

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.init = function() {

        Vendd.Environment.init({
            current: model.Environment,
            available: model.AvailableEnvironments
        });

    };

    wrapper.render = function() {

        $wrapper.html(Vendd.Handlebars.parse("inlineAdmin", model));

    };

    wrapper.bind = function() {

        var basePath = `${location.protocol}//${document.location.hostname}`

        var promises = [
            Vendd.jsLoader.load(`${basePath}/themes/templatethemetwo/js/Plugins/deep-diff.min.js`, document.body),
            Vendd.jsLoader.load(`//cdn.iframe.ly/embed.js?cancel=0`, document.body),
            Vendd.jsLoader.load(`${basePath}/themes/templatethemetwo/ckeditor5/CKFinderScripts/ckfinder.js`, document.body),
            Vendd.jsLoader.load(`${basePath}/themes/templatethemetwo/ckeditor5/vendd-editor.js`, document.body),
        ];

        Q.all(promises)
            .then(function () {

                var fetchEditableItem = function() {

                    if($('.x-control.x-article.news-article').length > 0)
                    { 
                        return {
                            Id: parseInt($('.x-article.news-article').eq(0).data('stats-itemid')) || LhApp.Context.Item.Id || 0,
                            Path: LhApp.Context.Item.Path,
                            Entity: LhApp.Context.Item.Entity,
                            Template: LhApp.Context.Item.Template
                        };
                    }

                    if($('.x-control.x-product-details.product-details-b').length > 0)
                    {
                        return {
                            Id: parseInt($('.x-control.x-product-details').eq(0).data('parent-id')) || LhApp.Context.Item.Id || 0,
                            Path: LhApp.Context.Item.Path,
                            Entity: LhApp.Context.Item.Entity,
                            Template: LhApp.Context.Item.Template
                        };
                    };
                    
                    return null;

                }
                
                var item = fetchEditableItem();

                if(!!!item)
                {
                    console.log('inline-editing is not allowed in this context');

                    return;
                }
                
                if(item.Id <= 0)
                {
                    throw new Error(`Item not found with id '${_itemId}'`);
                }

                var wrapper = $('.header-region .region-area-two');

                wrapper.css("position", "relative");

                var url = Vendd.api.path('admin', `app/frame/HtmlBox?ItemId=${item.Id}&ItemPathChecksum=${item.Path}&LanguageCode=${LhApp.Context.Language}&AddNewEntityCode=${item.Entity}&AddNewTemplateCode=${item.Template}`);

                var html = `
<div class="js-inline-admin-edit-page-toolbar">
    <a href = "javascript:void(0)" class="js-inline-admin-edit-page button icon icon-pencil"></a>
    <a href = "${url}" class="js-inline-admin-edit-popup button icon icon-pencil"></a>
</div >`;

                wrapper.append(html);

                $('.js-inline-admin-edit-page').on('click', function (e) {

                    e.preventDefault();
                    e.stopPropagation();

                    $('.js-inline-admin-edit-page-toolbar', wrapper).hide();

                    Vendd.inlineEdit.init();

                });

                $('.js-inline-admin-edit-popup', wrapper).fancybox({
                    type: 'iframe',
                    baseClass: "inline-admin-popup",
                    toolbar: false,
                    smallBtn: true
                });

            })
            .done();

        (function () {
            var wrapper = $('.inline-admin-environments');

            if (wrapper.length === 0) {

                return;

            }

            var selectElement = $("> select", wrapper);

            if (selectElement.length === 0) {

                return;

            }

            selectElement.val(Vendd.Environment.Current.Id).change();

            selectElement.on('change', function () {

                var basePath = `${location.protocol}//${document.location.hostname}`

                var promiseA = Q($.ajax({
                    type: "POST",
                    url: `${basePath}/basePath/services/api/InlineAdmin/SetEnvironment`,
                    data: JSON.stringify({
                        'Id': selectElement.val()
                    }),
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    ContentType: 'application/json; charset=UTF-8',
                    xhrFields: { withCredentials: true }
                }));

                var promiseB = Q($.ajax({
                    type: "POST",
                    url: `${basePath}/vendd/api/InlineAdmin//SetEnvironment`,
                    data: JSON.stringify({
                        'Id': selectElement.val()
                    }),
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    ContentType: 'application/json; charset=UTF-8',
                    xhrFields: { withCredentials: true }
                }));

                Q.all([promiseA, promiseB])
                    .then(function (response) {

                        window.location.reload();

                    })
                    .done();

            });

        })();
        
        //Listen for window post message
        window.PostMessages.subscribe('inline-admin', function (event, message) {

            var canParseUrl = function (url) {

                try {

                    new URL(url);

                } catch (error) {

                    return false;

                }

                return true;

            }

            if (typeof (event.origin) !== 'string'
                || !canParseUrl(event.origin)
                || !canParseUrl(LhApp.Context.InLineAdminEndpoint)) {

                return;

            }

            if (new URL(event.origin).origin != new URL(LhApp.Context.InLineAdminEndpoint).origin) {

                return;

            }

            if (message.Action === 'SetUser') {

                if (message.UserEmail) {
                    Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdmin({ 'LoginName': message.UserEmail.trim(), 'RedirectToAccount': message.RedirectToAccount }));
                } else if (message.UserId) {
                    Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserByIdInlineAdmin({ 'UserId': message.UserId, 'RedirectToAccount': message.RedirectToAccount }));
                }           
            }

            if (message.Action === 'SetOrder') {

                Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdmin({ 'LoginName': message.UserEmail.trim(), 'RedirectToAccount': message.RedirectToAccount, 'OrderId': message.OrderId }));
            }

        });

        var fancyOpts = {
            type: 'iframe',
            baseClass: "inline-admin-popup",
            toolbar: false,
            smallBtn: true,
            beforeLoad: function () {

                var self = this;

                self.src = self.src = (self.src || '') + '#' + encodeURIComponent(document.location.href)
            }
        };

        $("section.admin .iframe").fancybox(fancyOpts);

        $('.inline-admin-logout').on('click', '.js-logout', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.Logout());
        });

        $('.inline-clear-cache').on('click', '.js-clear-cache', function (e) {
            e.preventDefault();

            Vendd.api.call(Vendd.api.path('site', '/engine/clearcache'), null, {
                contentType: 'text/plain; charset=UTF-8'
            })
                .then(function (result) {

                    alert(result);
                    location.reload();

                })
                .then(null, function(error) {

                    var message = btoa(JSON.stringify(error.response || error));

                    var message = `Rebuild failed!\nA team of highly trained monkeys has been dispatched to deal with this situation. If you see them, send them this information as text: ${message}`;

                    alert(message);

                });

        });

        $('.inline-admin-reindex').on('click', '.js-reindex', function (e) {
            
            e.stopPropagation();
            e.preventDefault();

            Vendd.inlineEdit.uiLoader.show();

            Vendd.api.call(Vendd.api.path('admin', 'api/DataList/RefreshDatalist'), {})
                .then(function (result) {

                    alert('Rebuild completed successfully');
                    location.reload();
                    // Vendd.inlineEdit.uiLoader.hide();

                })
                .then(null, function(error) {

                    var message = btoa(JSON.stringify(error.response || error));

                    var message = `Rebuild failed!\nA team of highly trained monkeys has been dispatched to deal with this situation. If you see them, send them this information as text: ${message}`;

                    alert(message);

                });

        });

        $('.inline-admin-newguest').on('click', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.InlineAdmin.Messages.CheckForInlineAdmin(true));

        });
        $('.inline-admin-clearinterfaceuser').on('click', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserSelect.Messages.ClearInterfaceUser());

        });

        $('section.admin .shippingCountry').on('click', function (e) {
            e.preventDefault();
            window.location.href = LhApp.Function.Url.setParameterValue("country", $(this).data("country"));
        });

        $('.header-spacer').addClass('has-inline-admin');
        $('.header-region').addClass('has-inline-admin');

    };

    wrapper.newGuid = function newGuid() {
        return ([1e7] + [-1e3] + [-4e3] + [-8e3] + [-1e11]).replace(/[018]/g, (parseInt('$2') ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> parseInt('$2') / 4).toString(16));
    };

    Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.ClearInterfaceUserSuccess, wrapper, function (envelope) {
        location.reload();
    });

    if (hasCookie) {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.InlineAdmin.Messages.CheckForInlineAdmin());

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CheckForInlineAdminSuccess, wrapper, function (envelope) {

            model = envelope.message.data.model.data;
            if (model.CallCenter.InterfaceUserIsNewGuest)
                location.reload();
                
            wrapper.loading(true);

            wrapper.init();
            wrapper.render();
            wrapper.bind();
            
            var blueBorders = new window.Vendd.blueBorders(model);
            blueBorders.init()
                .then(function() {

                    blueBorders.build();
                    blueBorders.render();
                    blueBorders.bind();

                    wrapper.loading(false);

                })
                .done();
    
        });

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CheckForInlineAdminFailure, wrapper, function (envelope) {
            Cookies.set('InlineAdmin', '', { expires: 0, samesite: 'Lax' });
        });

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminSuccess, wrapper, function (envelope) {
            model = envelope.message.data.model;
            var redirectUrl = envelope.message.data.redirectUrl;

            hasCookie = Cookies.get('InlineAdmin');

            if (!hasCookie) {
                Cookies.set('InlineAdmin', wrapper.newGuid(), { expires: 1, samesite: 'Lax' });
            }

        });
    }

    (function () {

        const newGuid = function() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        }

        const createControl = function (element, definition, options) {

            var controlConstructor = Vendd.inlineEdit[definition.type];

            var ctl = new controlConstructor(element, definition, options);
            element.data('vendd-control', ctl);

            if (Array.isArray(definition.controls)) {

                definition.controls.forEach(function (childControlDefinition) {

                    var childElement = $('<div></div>');
                    childElement.appendTo(element);

                    var cctl = createControl(childElement, childControlDefinition);

                    cctl.parent = ctl;

                    ctl.controls.push(cctl);

                });

            }

            return ctl;

        }

        Vendd.inlineEdit.controlFactory.register('products', function () {

           var results = [];

           $('.x-product-details').each(function () {

                var wrapper = $(this);

                var formId = newGuid();
                var actionDiscardId = newGuid();
                var actionSaveId = newGuid();
                var actionReloadId = newGuid();
                var actionOpenPopupId = newGuid();

                var nameAttributeEditor = newGuid();
                var descriptionAttributeEditor = newGuid();
                var extendedDescriptionAttributeEditor = newGuid();

                var definition = {
                    id: formId,
                    type: 'itemForm',

                    datasource: {
                        id: 'Item',
                    },

                    controls: [
                        {
                            id: newGuid(),
                            type: 'actionContainer',

                            controls: [
                                {
                                    id: actionDiscardId,
                                    type: 'formDiscardAction',
                                },
                                {
                                    id: actionSaveId,
                                    type: 'formSaveAction',
                                },
                                {
                                    id: actionReloadId,
                                    type: 'dynamicAction',

                                    execute: function (sender) { Vendd.inlineEdit.uiLoader.show(); window.location.reload(); }
                                },
                                {
                                    id: actionOpenPopupId,
                                    type: 'dynamicAction',

                                    hasChanges: function (sender) {

                                        var self = sender;

                                        var form = self.getForm();

                                        return form !== undefined
                                            && typeof form.hasChanges === 'function'
                                            && !form.hasChanges();
                                            
                                    },
                                    execute: function (sender) {

                                        var self = sender;

                                        var form = self.getForm();

                                        if (form === undefined) {

                                            return;

                                        }

                                        var languageCode = Vendd.inlineEdit.languageManager.current.TwoLetterCode;

                                        $.fancybox.open({
                                            src: Vendd.api.path('admin', `app/frame/HtmlBox?ItemId=${form.itemId}&ItemPathChecksum=${form.path}&LanguageCode=${languageCode}&AddNewEntityCode=document&AddNewTemplateCode=newsdetails`),
                                            type: 'iframe',
                                            baseClass: "inline-admin-popup",
                                            toolbar: false,
                                            smallBtn: true
                                        });
                                    }
                                }
                            ]
                        },
                        {
                            id: newGuid(),
                            type: 'toolbarContainer',
                            cssClasses: 'js-inline-admin-edit-page-toolbar',

                            controls: [
                                {
                                    id: newGuid(),
                                    type: 'toolbarButton',
                                    cssClasses: 'icon icon-Refresh-1',

                                    action: actionDiscardId
                                },
                                {
                                    id: newGuid(),
                                    type: 'toolbarButton',
                                    cssClasses: 'icon icon-check4',

                                    action: actionSaveId
                                },
                                {
                                    id: newGuid(),
                                    type: 'toolbarButton',
                                    cssClasses: 'icon icon-exit2',

                                    action: actionReloadId
                                },
                                {
                                    id: newGuid(),
                                    type: 'toolbarButton',
                                    cssClasses: 'js-inline-admin-edit-popup icon icon-pencil',

                                    action: actionOpenPopupId
                                }
                            ]
                        },
                        {
                            id: newGuid(),
                            type: 'attributeEditorContainer',

                            controls: [
                                {
                                    id: nameAttributeEditor,
                                    type: 'attributeEditor',
                                    wrapperSelector: '.header h1.title',
                                    nameProvider: true,
                                    attribute: 'Products_Name',
                                    mode: 'text',
                                    datasource: {
                                        id: 'Item',
                                    }
                                },
                                {
                                    id: descriptionAttributeEditor,
                                    type: 'attributeEditor',
                                    wrapperSelector: '.header h4.subtitle',
                                    attribute: 'Products_Description',
                                    mode: 'text',
                                    datasource: {
                                        id: 'Item'
                                    }
                                },
                                {
                                    id: extendedDescriptionAttributeEditor,
                                    type: 'attributeEditor',
                                    wrapperSelector: { selector: '.product-details-region .region-area.region-area-five .description-container.dynamic-content', global: true },
                                    attribute: 'Products_ExtendedDescription',
                                    datasource: {
                                        id: 'Item'
                                    }
                                }
                            ]
                        }
                    ]
                };

                var options = {
                    itemId: wrapper.data('parent-id'),
                    path: LhApp.Context.Item.Path,
                    entity: 'product',

                    languageId: Vendd.inlineEdit.languageManager.current.Id,
                    siteId: LhApp.Context.Site.Id,
                };

                results.push(createControl($(this), definition, options));

           });

           return results;

        });

        Vendd.inlineEdit.controlFactory.register('articles', function() {

            var results = [];

            $('.x-article.news-article').each(function() {

                var wrapper = $(this);

                var formId = newGuid();
                var actionDiscardId = newGuid();
                var actionSaveId = newGuid();
                var actionReloadId = newGuid();
                var actionOpenPopupId = newGuid();

                var nameAttributeEditor = newGuid();
                var descriptionAttributeEditor = newGuid();
                var extendedDescriptionAttributeEditor = newGuid();

                var definition = {
                    id: formId,
                    type: 'itemForm',

                    datasource: {
                        id: 'Item',
                    },

                    controls: [
                        {
                            id: newGuid(),
                            type: 'actionContainer',

                            controls: [
                                {
                                    id: actionDiscardId,
                                    type: 'formDiscardAction',
                                },
                                {
                                    id: actionSaveId,
                                    type: 'formSaveAction',
                                },
                                {
                                    id: actionReloadId,
                                    type: 'dynamicAction',

                                    execute: function (sender) { Vendd.inlineEdit.uiLoader.show(); window.location.reload(); }
                                },
                                {
                                    id: actionOpenPopupId,
                                    type: 'dynamicAction',

                                    hasChanges: function (sender) {

                                        var self = sender;

                                        var form = self.getForm();

                                        return form !== undefined
                                            && typeof form.hasChanges === 'function'
                                            && !form.hasChanges();

                                    },
                                    execute: function (sender) {

                                        var self = sender;

                                        var form = self.getForm();

                                        if (form === undefined) {

                                            return;

                                        }

                                        var languageCode = Vendd.inlineEdit.languageManager.current.TwoLetterCode;

                                        $.fancybox.open({
                                            src: Vendd.api.path('admin', `app/frame/HtmlBox?ItemId=${form.itemId}&ItemPathChecksum=${form.path}&LanguageCode=${languageCode}&AddNewEntityCode=document&AddNewTemplateCode=newsdetails`),
                                            type: 'iframe',
                                            baseClass: "inline-admin-popup",
                                            toolbar: false,
                                            smallBtn: true
                                        });
                                    }
                                }
                            ]
                        },
                        {
                            id: newGuid(),
                            type: 'toolbarContainer',
                            cssClasses: 'js-inline-admin-edit-page-toolbar',

                            controls: [
                                {
                                    id: newGuid(),
                                    type: 'toolbarButton',
                                    cssClasses: 'icon icon-Refresh-1',

                                    action: actionDiscardId
                                },
                                {
                                    id: newGuid(),
                                    type: 'toolbarButton',
                                    cssClasses: 'icon icon-check4',

                                    action: actionSaveId
                                },
                                {
                                    id: newGuid(),
                                    type: 'toolbarButton',
                                    cssClasses: 'icon icon-exit2',

                                    action: actionReloadId
                                },
                                {
                                    id: newGuid(),
                                    type: 'toolbarButton',
                                    cssClasses: 'js-inline-admin-edit-popup icon icon-pencil',

                                    action: actionOpenPopupId
                                }
                            ]
                        },
                        {
                            id: newGuid(),
                            type: 'attributeEditorContainer',

                            controls: [
                                {
                                    id: nameAttributeEditor,
                                    type: 'attributeEditor',
                                    wrapperSelector: '.title-container .title',
                                    nameProvider: true,
                                    attribute: 'Items_Name',
                                    mode: 'text',
                                    datasource: {
                                        id: 'Item',
                                    }
                                },
                                {
                                    id: descriptionAttributeEditor,
                                    type: 'attributeEditor',
                                    wrapperSelector: '.title-container .subtitle',
                                    attribute: 'Documents_Intro',
                                    mode: 'text',
                                    datasource: {
                                        id: 'Item'
                                    }
                                },
                                {
                                    id: extendedDescriptionAttributeEditor,
                                    type: 'attributeEditor',
                                    wrapperSelector: '.description-container.dynamic-content',
                                    attribute: 'Documents_MainContent',
                                    datasource: {
                                        id: 'Item'
                                    }
                                }
                            ]
                        }
                    ]
                };

                var options = {
                    itemId: wrapper.data('stats-itemid'),
                    path: LhApp.Context.Item.Path,
                    entity: 'document',

                    languageId: Vendd.inlineEdit.languageManager.current.Id,
                    siteId: LhApp.Context.Site.Id,
                };

                results.push(createControl($(this), definition, options));

            });

            return results;

        });

    })();

});
